//#region src/services/cwc-window.service.ts
var e = (e, t) => {
	let n = `scrollbars=yes,resizable=yes,status=no,location=no,toolbar=no,menubar=no,width=${Math.min(window.screen.width, 1200)},height=${Math.min(window.screen.height, 800)},left=0,top=0`, r = window.open(e, t, n);
	return r.focus(), r;
}, t = (t, n) => {
	let r = document.createElement("form"), i = "cwcwidget";
	r.setAttribute("method", "post"), r.setAttribute("action", t), r.setAttribute("target", i), Object.keys(n).forEach((e) => {
		let t = document.createElement("input");
		t.type = "hidden", t.name = e, t.value = n[e], r.appendChild(t);
	}), document.body.appendChild(r);
	let a = e("", i);
	return r.submit(), document.body.removeChild(r), a;
};
//#endregion
export { t };

//# sourceMappingURL=cwc-window.service-BDYTgDsB.js.map